function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

var CurrencyDisabledView = /*#__PURE__*/function (_React$Component) {
  _inherits(CurrencyDisabledView, _React$Component);

  /** *******************static************************** */

  /** *******************life cycle************************** */
  function CurrencyDisabledView(props) {
    _classCallCheck(this, CurrencyDisabledView);

    return _possibleConstructorReturn(this, _getPrototypeOf(CurrencyDisabledView).call(this, props));
  }
  /** *******************inner method************************** */


  _createClass(CurrencyDisabledView, [{
    key: "formatAmount",
    value: function formatAmount(amount) {
      var precision = this.props.precision;
      return amount.toFixed(precision);
    }
    /** *******************render************************** */

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          amount = _this$props.amount,
          adjustedAmount = _this$props.adjustedAmount;
      var ccyCode = this.props.ccyCode;
      var hasAdjusted = amount !== adjustedAmount; //判断是否调整过金额

      if (ccyCode === 'CNY') {
        ccyCode = '￥';
      }

      return React.createElement("div", {
        className: "control-view-item"
      }, React.createElement("div", {
        className: "control"
      }, React.createElement("span", {
        className: "amount-single"
      }, React.createElement("i", {
        className: "symbol"
      }, ccyCode), React.createElement("span", null, this.formatAmount(adjustedAmount)), hasAdjusted && React.createElement("span", {
        className: "consume-amount"
      }, React.createElement("i", {
        className: "symbol"
      }, ccyCode), React.createElement("span", {
        className: "consume-amount"
      }, this.formatAmount(amount))))));
    }
  }]);

  return CurrencyDisabledView;
}(React.Component);

_defineProperty(CurrencyDisabledView, "propTypes", {
  ccyCode: PropTypes.string,
  amount: PropTypes.number,
  adjustedAmount: PropTypes.number,
  hasAdjusted: PropTypes.bool
});

_defineProperty(CurrencyDisabledView, "defaultProps", {
  ccyCode: '￥',
  amount: '',
  adjustedAmount: '',
  hasAdjusted: false
});

export default CurrencyDisabledView;
//# sourceMappingURL=CurrencyDisabledView.js.map
